var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 2.4C13.1626 2.4 13.6999 2.93726 13.6999 3.6V4.8C13.6999 5.46274 13.1626 6 12.4999 6C11.8372 6 11.2999 5.46274 11.2999 4.8V3.6C11.2999 2.93726 11.8372 2.4 12.4999 2.4Z",
    fill: "#6661F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2999 12C17.2999 14.651 15.1509 16.8 12.4999 16.8C9.84894 16.8 7.6999 14.651 7.6999 12C7.6999 9.34904 9.84894 7.2 12.4999 7.2C15.1509 7.2 17.2999 9.34904 17.2999 12Z",
    fill: "#6661F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7426 17.9397L17.5911 18.7882C18.0598 19.2568 18.8196 19.2568 19.2882 18.7882C19.7568 18.3195 19.7568 17.5598 19.2882 17.0911L18.4397 16.2426C17.971 15.774 17.2112 15.774 16.7426 16.2426C16.274 16.7112 16.274 17.471 16.7426 17.9397Z",
    fill: "#6661F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2881 5.21171C19.7567 5.68034 19.7567 6.44014 19.2881 6.90877L18.4396 7.7573C17.9709 8.22593 17.2111 8.22593 16.7425 7.7573C16.2739 7.28867 16.2739 6.52887 16.7425 6.06024L17.591 5.21171C18.0597 4.74308 18.8195 4.74308 19.2881 5.21171Z",
    fill: "#6661F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8999 13.2C21.5626 13.2 22.0999 12.6627 22.0999 12C22.0999 11.3373 21.5626 10.8 20.8999 10.8H19.6999C19.0372 10.8 18.4999 11.3373 18.4999 12C18.4999 12.6627 19.0372 13.2 19.6999 13.2H20.8999Z",
    fill: "#6661F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 18C13.1626 18 13.6999 18.5373 13.6999 19.2V20.4C13.6999 21.0627 13.1626 21.6 12.4999 21.6C11.8372 21.6 11.2999 21.0627 11.2999 20.4V19.2C11.2999 18.5373 11.8372 18 12.4999 18Z",
    fill: "#6661F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56028 7.75732C7.0289 8.22595 7.7887 8.22595 8.25733 7.75732C8.72596 7.28869 8.72596 6.52889 8.25733 6.06026L7.4088 5.21173C6.94017 4.74311 6.18038 4.74311 5.71175 5.21173C5.24312 5.68036 5.24312 6.44016 5.71175 6.90879L6.56028 7.75732Z",
    fill: "#6661F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25722 17.9396L7.40869 18.7882C6.94006 19.2568 6.18026 19.2568 5.71164 18.7882C5.24301 18.3195 5.24301 17.5597 5.71164 17.0911L6.56016 16.2426C7.02879 15.7739 7.78859 15.7739 8.25722 16.2426C8.72585 16.7112 8.72585 17.471 8.25722 17.9396Z",
    fill: "#6661F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2999 13.2C5.96264 13.2 6.4999 12.6627 6.4999 12C6.4999 11.3373 5.96264 10.8 5.2999 10.8H4.0999C3.43716 10.8 2.8999 11.3373 2.8999 12C2.8999 12.6627 3.43716 13.2 4.0999 13.2H5.2999Z",
    fill: "#6661F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeSun);
export default __webpack_public_path__ + "static/media/theme-sun.3a3a6eb6e79c5740f7207c2fac8e9ad9.svg";
export { ForwardRef as ReactComponent };